import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "colorScheme", "dataTestId", "disabled", "error", "indeterminate"];
import React, { forwardRef, useEffect, useRef } from 'react';
import { describe } from '@amzn/stencil-react-desc';
import { buildDataTestProps, mergeRefs } from "../../utils";
import CheckboxSvg from "./CheckboxSvg";
import Tick from "./Tick";
import { CheckHidden, CheckOuter, IndeterminateBar } from "./helperComponents";
import { CheckboxColorScheme } from "./interfaces";
import { checkboxPropTypes } from "./propTypes";
import { jsx as ___EmotionJSX } from "@emotion/core";
var CheckboxBase = /*#__PURE__*/forwardRef(function (_ref, externalRef) {
  var children = _ref.children,
      _ref$colorScheme = _ref.colorScheme,
      colorScheme = _ref$colorScheme === void 0 ? CheckboxColorScheme.Default : _ref$colorScheme,
      dataTestId = _ref.dataTestId,
      disabled = _ref.disabled,
      error = _ref.error,
      indeterminate = _ref.indeterminate,
      props = _objectWithoutProperties(_ref, _excluded);

  var dataTestProps = buildDataTestProps({
    dataTestComponent: 'StencilReactCheckbox',
    dataTestId: dataTestId
  });
  var inputDataTestProps = buildDataTestProps({
    dataTestComponent: 'StencilReactCheckboxInput',
    dataTestId: dataTestId
  });
  var checkboxRef = useRef(null);
  useEffect(function () {
    var checkbox = checkboxRef.current;

    if (!checkbox) {
      return;
    }

    checkbox.indeterminate = !!indeterminate;
  }, [indeterminate]);
  return ___EmotionJSX(CheckOuter, dataTestProps, ___EmotionJSX(CheckHidden, _extends({}, inputDataTestProps, props, {
    className: "stencilCheckboxHidden",
    disabled: disabled,
    ref: mergeRefs(checkboxRef, externalRef),
    type: "checkbox"
  })), ___EmotionJSX(Tick, {
    colorScheme: colorScheme,
    disabled: disabled,
    error: error
  }, ___EmotionJSX(CheckboxSvg, null), ___EmotionJSX(IndeterminateBar, {
    className: "stencilIndeterminateBar"
  })));
});
var Checkbox = describe(CheckboxBase).description('Basic form element for selecting an option that is either on or off.');
Checkbox.propTypes = checkboxPropTypes;
Checkbox.displayName = 'Checkbox';
export default Checkbox;